"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon"));
var Popup_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Popup"));
var Field_1 = require("../Field/Field");
var utils_1 = require("./utils");
var AddressField_types_1 = require("./AddressField.types");
require("./AddressField.css");
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function AddressField(props) {
    var _this = this;
    var _a;
    var className = props.className, fieldClassName = props.fieldClassName, i18n = props.i18n, resolveName = props.resolveName, onChange = props.onChange, otherProps = __rest(props, ["className", "fieldClassName", "i18n", "resolveName", "onChange"]);
    var _b = (0, react_2.useState)(props.value || ''), inputValue = _b[0], setInputValue = _b[1];
    var _c = (0, react_2.useState)(''), address = _c[0], setAddress = _c[1];
    var timeout = (0, react_2.useRef)();
    var _d = (0, react_2.useState)(), valid = _d[0], setValid = _d[1];
    var _e = (0, react_2.useState)(), loading = _e[0], setLoading = _e[1];
    (0, react_2.useEffect)(function () {
        return function () {
            clearTimeout(timeout.current);
        };
    }, []);
    var handleChange = (0, react_2.useCallback)(function (evt, data) {
        setInputValue(data.value);
        setValid(undefined);
        setAddress('');
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var address, error, resolvedAddress, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        address = data.value;
                        error = undefined;
                        if (!(0, utils_1.isValid)(data.value)) return [3 /*break*/, 1];
                        setValid(true);
                        return [3 /*break*/, 6];
                    case 1:
                        // If address is not valid try to resolve it as a name
                        setLoading(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, resolveName(data.value)];
                    case 3:
                        resolvedAddress = _a.sent();
                        if (resolvedAddress) {
                            setValid(true);
                            setAddress(resolvedAddress);
                            address = resolvedAddress;
                        }
                        else {
                            setValid(false);
                            error = new Error(AddressField_types_1.AddressFieldErrors.INVALID_ADDRESS_OR_NAME);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        error = new Error(AddressField_types_1.AddressFieldErrors.ERROR_RESOLVING_NAME);
                        setValid(false);
                        return [3 /*break*/, 5];
                    case 5:
                        setLoading(false);
                        _a.label = 6;
                    case 6:
                        evt.target.focus();
                        if (onChange) {
                            onChange(evt, __assign(__assign({}, data), { value: address, error: error }));
                        }
                        return [2 /*return*/];
                }
            });
        }); }, 800);
    }, [onChange]);
    var additionalProps = valid
        ? {
            icon: (react_1.default.createElement(Icon_1.default, { color: "green", "data-testid": "check-icon", size: "large", name: "check circle" }))
        }
        : {};
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('dui-address-field', className) },
        address && (react_1.default.createElement(Popup_1.default, { position: "top center", className: "dui-address-field__address-popup", on: "hover", content: address, trigger: react_1.default.createElement("span", { "data-testid": "resolved-address", className: "dui-address-field__address" }, (0, utils_1.shorten)(address)) })),
        react_1.default.createElement(Field_1.Field, __assign({}, otherProps, { type: "text", placeholder: (_a = props.placeholder) !== null && _a !== void 0 ? _a : 'Address or name', value: inputValue || '', message: (valid === false
                ? (i18n === null || i18n === void 0 ? void 0 : i18n.errorMessage) || 'This is not a valid name or address'
                : undefined) || props.message, error: valid === false || props.error, loading: props.loading || loading, disabled: props.disabled || loading, input: { autoComplete: 'off', name: 'address', id: 'address' }, onChange: handleChange, className: (0, classnames_1.default)(fieldClassName, {
                'dui-address-field__input--with-address': !!address
            }) }, additionalProps))));
}
exports.default = AddressField;
